/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Sections components

// Avatars page components

// Avatars page components code

import React, { useRef, useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import { useParams } from "react-router-dom";
import MKBox from "../../components/MKBox";
import models from "../../store/constant/models";
import MainLayout from "../MainLayout";
import GridCardSelectNewJob from "../../views/GridCard/GridCardSelectNewJob";
import GridCardMapNewJob from "../../views/GridCard/GridCardMapNewJob";

function ComputingNewJob() {
  const { modelID } = useParams();
  const model = models.find((m) => m.id === modelID);

  const [BreadcrumbsRoutes] = useState([
    { label: "Home", route: "/home" },
    { label: "Computing", route: "/computing" },
    { label: model.type },
  ]);

  const mapRef = useRef();
  const [map, setMap] = useState(null);

  return (
    <MainLayout breadcrumbsRoutes={BreadcrumbsRoutes}>
      <MKBox component="section">
        <MKBox width="100%" pt={0.1} bgColor="white">
          <Grid2 container justifyContent="space-evenly" sx={{ height: 1, width: 1 }}>
            <Grid2
              container
              xs={12}
              md={4}
              lg={4}
              xxl={3.5}
              xxxl={3}
              xxxxl={2}
              justifyContent="space-evenly"
            >
              <Grid2 md={12} sx={{ height: { md: "1" } }} p={1}>
                <GridCardSelectNewJob model={model} map={map} />
              </Grid2>
              {/* <Grid2 xs={6} md={12} sx={{ height: { md: "0.35", lg: "0.35" } }} p={1}> */}
              {/*   <GridCardLayersNewJob map={map} /> */}
              {/* </Grid2> */}
            </Grid2>
            <Grid2 xs={12} md={8} lg={8} xxl={8.5} xxxl={9} xxxxl={10} p={1}>
              <GridCardMapNewJob
                productionInfo={model}
                map={map}
                mapRef={mapRef}
                setMap={setMap}
                className="ol-map-high"
              />
            </Grid2>
          </Grid2>
        </MKBox>
      </MKBox>
    </MainLayout>
  );
}

export default ComputingNewJob;
